import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["paymentFilters"]
  static values = { visible: Boolean }

  connect() {
    this.updateVisibility()
  }

  showPaymentFilters() {
    this.visibleValue = true
  }

  updateVisibility() {
    if (this.visibleValue) {
      this.paymentFiltersTarget.classList.remove('d-none')
    } else {
      this.paymentFiltersTarget.classList.add('d-none')
    }
  }
}
